import { defineStore } from "pinia";
import { CHECKOUT_CONSTANTS } from "~/constants/checkout-constants";
import { COMMON_CONSTANTS } from "~/constants/common-constants";
import type { ILoginTypeResponse } from "~/types/login";

// Use Pick to create a new type with only the required fields
type LoginTypeData = Pick<
  ILoginTypeResponse["data"],
  "organization_id" | "login_type" | "has_referral" | "is_public_access"
>;

const getInitialData = (): LoginTypeData => ({
  organization_id: "",
  login_type: "",
  has_referral: "",
  is_public_access: false,
});

export const useLoginStore = defineStore("loginStore", {
  state: () => ({
    loginTypeData: getInitialData(),
    isOtpSent: false,
    email: "",
    mobile_number: "",
  }),
  actions: {
    setLoginTypeData(data: LoginTypeData) {
      this.loginTypeData = data;
    },
    clearLoginTypeData() {
      this.loginTypeData = getInitialData();
    },
    setIsOtpSent(status: boolean) {
      this.isOtpSent = status;
    },
    setEmail(email: string) {
      this.email = email;
    },
    setMobileNumber(mobile_number: string) {
      this.mobile_number = mobile_number;
    },
    clearMobileNumber() {
      this.mobile_number = "";
    },
    clearEmail() {
      this.email = "";
    },
    clearIsOtpSent() {
      this.isOtpSent = false;
    },
  },
  getters: {
    loginType: (state) => state.loginTypeData.login_type,
    organizationId: (state) => state.loginTypeData.organization_id,
    hasReferral: (state) => state.loginTypeData.has_referral,
    getCouponType: (state) => {
      if (
        state.loginTypeData.has_referral === COMMON_CONSTANTS.POSITIVE_VALUE
      ) {
        return CHECKOUT_CONSTANTS.REFERRAL;
      }
      return "";
    },
    getIsOtpSent: (state) => state.isOtpSent,
    getEmail: (state) => state.email,
    getMobileNumber: (state) => state.mobile_number,
  },
});
